import { DashboardKpiParams, DashboardKpiPeriod } from "types";

export type DashboardParamsPeriod = DashboardKpiPeriod | "TIME_RANGE";

export const toDashboardKpiPeriod = (period: DashboardParamsPeriod): DashboardKpiPeriod =>
  period === "TIME_RANGE" ? "CUSTOM" : period;

export const normalizeDashboardDate = (value: string) => {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return undefined;
  }

  if (/^\d{4}-\d{2}-\d{2}$/.test(trimmedValue)) {
    return trimmedValue;
  }

  const localDateMatch = trimmedValue.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);

  if (!localDateMatch) {
    return undefined;
  }

  const [, day, month, year] = localDateMatch;
  return `${year}-${month}-${day}`;
};

export const buildDashboardParams = (
  period: DashboardParamsPeriod,
  dateFrom: string,
  dateTo: string,
): DashboardKpiParams | null => {
  const normalizedPeriod = toDashboardKpiPeriod(period);
  const params: DashboardKpiParams = { period: normalizedPeriod };

  if (normalizedPeriod !== "CUSTOM") {
    return params;
  }

  const normalizedDateFrom = normalizeDashboardDate(dateFrom);
  const normalizedDateTo = normalizeDashboardDate(dateTo);

  if (!normalizedDateFrom || !normalizedDateTo) {
    return null;
  }

  return {
    ...params,
    from: normalizedDateFrom,
    to: normalizedDateTo,
  };
};
